import { Dropdown } from '@symphony-ui/uitoolkit-components';
import CloseIcon from 'components/custom-table/filters/CloseIcon';
import * as React from 'react';
import useOption from 'components/customHooks';
const BookrunnersPanel = function TimestampFilterElement({ column, close }) {
    const [id, setId] = React.useState(() => column.getFilterValue());
    const options = useOption('/syndicate/parties/options');
    const onChange = React.useCallback((event) => {
        const newValue = event.target.value !== null ? event.target.value.value : undefined;
        setId(newValue);
        column.setFilterValue(newValue);
    }, [column]);
    return (React.createElement("div", { className: "co-check-panel" },
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '15rem' } },
            React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginBottom: '0.5rem' } },
                React.createElement(CloseIcon, { onClick: close })),
            React.createElement(Dropdown, { isInputClearable: true, onChange: onChange, options: options, value: options.find(o => 'value' in o && o.value === id) }))));
};
export default BookrunnersPanel;
